module.exports = __webpack_public_path__ + "static/media/zeya_folds_herarms02.9882d21c.png";